<template>
  <AlertDialogTitle
    data-slot="alert-dialog-title"
    v-bind="delegatedProps"
    :class="cn('tw:type-subtitle', props.class)"
  >
    <slot />
  </AlertDialogTitle>
</template>

<script setup>
import { reactiveOmit } from '@vueuse/core';
import { cn } from '@/shared/utilities/classes';
import { AlertDialogTitle } from 'reka-ui';

const props = defineProps({
  asChild: { default: undefined, type: Boolean, required: false },
  as: { default: undefined, type: null, required: false },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');
</script>
